













import {
  DynamicDocumentItem,
  DynamicDocumentItemData,
  InstallationModule,
  InstallationModuleData,
  Material,
  MechanicInstallation,
  StatusFlags
} from "@/types";
import { isItemRequired } from "@/utilities";

import SerialnumbersManager from "@/containers/serialnumbers-manager";

import Vue, { PropType } from "vue";
import { InstallationModuleStatus } from "@/store/modules/installation";

export default Vue.extend({
  components: {
    SerialnumbersManager
  },

  props: {
    installation: { type: Object as PropType<MechanicInstallation> },
    item: Object as PropType<DynamicDocumentItem>,
    moduleData: Object as PropType<InstallationModuleData>,
    module: { type: Object as PropType<InstallationModule> }
  },

  computed: {
    isRequired(): boolean {
      const documentData: DynamicDocumentItemData[] = [
        { field: this.item.field, value: undefined }
      ];
      return isItemRequired(this.item, documentData, this.moduleData);
    },

    flags(): StatusFlags {
      return this.module.flags || {};
    },

    meters(): Material[] {
      return this.$store.state.materials.meters.items;
    },

    // The Teltonika communication-module serial validates against the pattern
    // configured on the matching meter hardware type in the backend (brand ===
    // the selected meterType, e.g. "Teltonika" → ^6[0-9]{9}$), not a hardcoded
    // rule. Scoped to this field only, so the datalogger/battery/kWh serials
    // that share this renderer keep their permissive default. Returns undefined
    // (→ the manager's "(.*?)" default) when the hardware type has no pattern
    // configured yet, preserving today's behaviour until it's set.
    patterns(): string[] | undefined {
      if (this.item.field !== "communicationModuleSerialNumber") {
        return undefined;
      }

      // meterType is single-select (a string), but legacy installs may still
      // store it array-shaped — normalise before matching the hardware brand.
      const raw = this.meterType as unknown as string | string[] | undefined;
      const selected = Array.isArray(raw) ? raw[0] : raw;

      const meter = this.meters.find(meter => meter.brand === selected);
      const patterns = meter?.types?.flatMap(type => type.patterns ?? []) ?? [];

      return patterns.length ? patterns : undefined;
    },

    isProcessing(): boolean {
      return this.status.status === "processing";
    },

    status(): InstallationModuleStatus {
      return this.$store.getters["installation/status"](this.installation.id, this.module.type);
    },

    meterType(): string {
      const documentData = this.$store.getters["deliveryDocuments/data"](
        this.installation.id,
        this.module.type
      );
      return documentData.find((item: DynamicDocumentItemData) => item.field === "meterType")
        ?.value;
    }
  },

  mounted() {
    this.checkType();
  },

  destroyed() {
    this.checkType();
  },

  methods: {
    checkType() {
      const documentData = this.$store.getters["deliveryDocuments/data"](
        this.installation.id,
        this.module.type
      );
      const meterType = documentData.find(
        (item: DynamicDocumentItemData) => item.field === "meterType"
      );

      // Get the serial number from the current field
      const serialNumber = this.moduleData[this.item.field]?.[0]?.serialNumber;

      let meterId = null;

      if (serialNumber) {
        const type = this.$store.getters["materials/meters/findItemBySn"](serialNumber);
        meterId = type?.id || null;
      }

      if (this.moduleData.meterId !== meterId) {
        this.$set(this.moduleData, "meterId", meterId);
      }
      this.save();
    },

    save() {
      this.$emit("save:module");
      this.$emit("save:document");
    }
  }
});
